import { Alert, AlertTitle } from "@/components/ui/alert";
import { useTranslation } from "react-i18next";

export const ContestAgreementsError = () => {
  const { t } = useTranslation();
  return (
    <div className="space-2">
      <Alert>
        <AlertTitle className="mb-0">
          {t("contestAgreements.errors.agreementSigned")}
        </AlertTitle>
      </Alert>
    </div>
  );
};
